// src/utils/logger.js
const logger = {
    enabled: import.meta.env.VITE_DEBUG === 'true',
    log: (...args) => {
      if (logger.enabled) {
        console.log(...args);
      }
    },
    warn: (...args) => {
      if (logger.enabled) {
        console.warn(...args);
      }
    },
    error: (...args) => {
      if (logger.enabled) {
        console.error(...args);
      }
    }
  };
  
  export default logger;
  